module.exports = __webpack_public_path__ + "assets/img/img-fv-01.b36ac102.png";